var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background-container"},[_c('RedLens',{staticClass:"red-lens"}),_c('TurquoiseLens',{staticClass:"turquoise-lens"}),_c('YellowLens',{staticClass:"yellow-lens"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }